import lodashCloneDeep from "lodash/cloneDeep";

import { httpGet } from "@/services/api.service";

import {
  ENDPOINT_GLOBAL_ISSUES_CONFIG,
  ENDPOINT_WOD,
} from "@/common/constants/api";

export { _getIssuesConfig as getIssuesConfig };
export { _getIssuesById as getIssuesById };
export { _getGlobalIssuesData as getGlobalIssuesData };

let globalIssuesData = null;

const _getIssuesConfig = async () => {
  try {
    const url = ENDPOINT_GLOBAL_ISSUES_CONFIG;
    const result = await httpGet({ url });
    const { data } = JSON.parse(result);
    return data;
  } catch (error) {
    Promise.reject(
      "Issue getting global issues config in issues.service.js: " +
        JSON.stringify(error)
    );
    return null;
  }
};

const _getIssuesById = async (id) => {
  try {
    const url = `${ENDPOINT_WOD}/global-issues/${id}`;
    const result = await httpGet({ url });
    const { data } = JSON.parse(result);
    return data;
  } catch (error) {
    Promise.reject(
      "Issue getting global issues config in issues.service.js: " +
        JSON.stringify(error)
    );
    return null;
  }
};

const _getGlobalIssuesData = async (force) => {
  if (!globalIssuesData || force) {
    try {
      let issuesData = [];
      const issuesConfig = await _getIssuesConfig();
      if (!issuesConfig) {
        throw "Error getting global issues config";
      }
      await Promise.all(
        issuesConfig.map(async (issue) => {
          const validatedIssue = _validateIssue(await _getIssuesById(issue.id));
          if (validatedIssue) {
            issuesData.push(validatedIssue);
          } else {
            console.error("Missing data for global issue: " + issue.id);
          }
        })
      );
      if (issuesData && issuesData.length > 0) {
        globalIssuesData = issuesData;
      } else {
        throw "Error getting global issues data.";
      }
      return issuesData;
    } catch (error) {
      console.error("Global Issues API: " + error);
      return [
        {
          label: "",
          id: "nodata",
          isActive: true,
          gridColumn: 1,
          profile: [
            {
              type: "nodatamessage",
              title: "",
              body:
                'Sorry, this page isn’t working right now. To report this, contact <a href="mailto:support@seerist.com">support@seerist.com</a>',
            },
          ],
        },
      ];
    }
  }
  return lodashCloneDeep(globalIssuesData);
};

const _validateIssue = (issue) => {
  return issue;
};
